var _rect, _path, _path2, _g, _path3, _path4, _path5, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBombsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    viewBox: "0 0 105 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 104,
    height: 44,
    rx: 7.5,
    fill: "#27191B",
    stroke: "url(#paint0_linear_621_421)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3144 2.95136C56.6742 2.57504 55.8556 2.79837 55.486 3.45017L53.1142 7.63296C52.0466 7.44494 50.948 7.34688 49.8265 7.34688C39.4289 7.34688 31 15.7758 31 26.1734C31 36.571 39.4289 44.9999 49.8265 44.9999C60.2241 44.9999 68.6531 36.571 68.6531 26.1734C68.6531 20.7725 66.3788 15.9028 62.7357 12.4696L64.7592 8.90127C65.1288 8.24947 64.9094 7.41601 64.2692 7.03969L57.3144 2.95136Z",
    fill: "#34384F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0902 0.00511045C69.2754 -0.109197 72.1008 1.7157 73.7094 3.30835C74.2402 3.83386 74.2402 4.68589 73.7094 5.2114C73.1786 5.73691 72.318 5.73691 71.7872 5.2114C70.451 3.88845 68.3155 2.61833 66.1887 2.69466C64.2445 2.76443 61.7814 3.99496 59.7298 8.81904C59.4385 9.50399 58.6416 9.82546 57.9498 9.53706C57.2579 9.24866 56.9332 8.4596 57.2245 7.77466C59.5223 2.37173 62.7224 0.125973 66.0902 0.00511045Z",
    fill: "#FF9299"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_621_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.486 3.45022C55.8556 2.79841 56.6742 2.57509 57.3144 2.95141L64.2692 7.03973C64.9094 7.41605 65.1288 8.24951 64.7592 8.90132L61.3954 14.8333L52.1223 9.38219L55.486 3.45022Z",
    fill: "#34384F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4031 26.1735C68.4031 36.433 60.0861 44.75 49.8265 44.75C39.567 44.75 31.25 36.433 31.25 26.1735C31.25 15.9139 39.567 7.59692 49.8265 7.59692C60.0861 7.59692 68.4031 15.9139 68.4031 26.1735Z",
    fill: "#34384F",
    stroke: "url(#paint1_linear_621_421)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7348 25.8924C67.7348 35.6853 59.6629 43.6225 49.7058 43.6225C46.1539 43.628 42.6802 42.5968 39.7246 40.6596C42.1508 41.7239 44.7783 42.272 47.435 42.268C57.8862 42.268 66.3583 33.9371 66.3583 23.6592C66.3632 21.0448 65.8059 18.459 64.7228 16.0715C66.6933 18.9797 67.7416 22.3977 67.7348 25.8924Z",
    fill: "url(#paint2_linear_621_421)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M37.0505 21.1406C36.6161 24.2857 39.1295 27.7973 39.1295 27.7973L38.7073 30.9528L41.0528 31.749L41.8441 28.629L42.7121 28.6705L42.6078 32.2747L45.2287 32.4951L45.7324 29.2791C45.7324 29.2791 46.4716 29.2238 46.5759 29.3033C46.6802 29.3829 46.3575 32.9023 46.3575 32.9023L48.7087 33L49.1602 29.4252C51.024 29.2653 54.1511 27.244 54.8112 24.4586C55.7346 20.9426 53.288 16.0952 47.0844 15.1477C40.8808 14.2002 37.4865 17.9998 37.0505 21.1406ZM49.4658 20.5855C50.531 21.0558 50.9531 22.5627 50.4087 23.9502C49.8643 25.3378 48.5595 26.0813 47.4927 25.6101C46.4259 25.139 46.0054 23.6364 46.5523 22.248C47.0991 20.8596 48.4006 20.1178 49.4658 20.5881V20.5855ZM41.9069 19.23C42.8523 19.3294 43.5238 20.4109 43.4081 21.6428C43.2924 22.8748 42.4301 23.7894 41.4839 23.6892C40.5377 23.5889 39.8662 22.5082 39.9827 21.2772C40.0993 20.0461 40.9591 19.128 41.9069 19.23Z",
    fill: "url(#paint3_linear_621_421)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_621_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 33C54.299 33 59 28.0751 59 22C59 15.9249 54.299 11 48.5 11C42.701 11 38 15.9249 38 22C38 28.0751 42.701 33 48.5 33Z",
    fill: "url(#paint4_radial_621_421)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_621_521",
    x: 52.1223,
    y: -1.23145,
    width: 12.8164,
    height: 16.0647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_621_521",
    x: 28,
    y: 1,
    width: 41,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_621_521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_421",
    x1: 52.5,
    y1: 0,
    x2: 52.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82F2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_421",
    x1: 36.5,
    y1: 13.5,
    x2: 50,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686C88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_421",
    x1: 53.7297,
    y1: 16.0715,
    x2: 53.7297,
    y2: 43.6226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#704F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704F4F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_421",
    x1: 46,
    y1: 15,
    x2: 46,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_621_421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5 22) rotate(90) scale(11 10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombsmall);
export default __webpack_public_path__ + "static/media/bombsmall.ef4c2b055b8652f5fe8f336bf64942e7.svg";
export { ForwardRef as ReactComponent };